package com.milta.core.localization.translations.ro

import com.milta.core.localization.AdminUsersStrings

internal val AdminUsers = AdminUsersStrings(
    loading = "Se încarcă…",
    errorNoConnection = "Serverul nu poate fi contactat — verifică-ți conexiunea.",
    errorGeneric = "A apărut o eroare. Încearcă din nou mai târziu.",
    readOnlyNotice = "🔒 Doar vizualizare — niciun cont nu poate fi creat, modificat sau suspendat din acest ecran momentan.",
    kpiAccountsLabel = "Conturi",
    kpiAccountsSubtitle = "toate rolurile",
    kpiDriversLabel = "Șoferi",
    kpiDriversSubtitle = "fără echipă proprie",
    kpiPatronsLabel = "Proprietari",
    kpiPatronsOrgSingular = "organizație",
    kpiPatronsOrgPlural = "organizații",
    kpiActiveSubsLabel = "Abonamente active",
    kpiActiveSubsSubtitle = "activ + perioadă de grație",
    kpiAtRiskLabel = "Cu risc",
    kpiAtRiskSubtitle = "perioadă de probă sau expirat",
    searchPlaceholder = "Caută după nume, email, organizație…",
    expandAllAction = "Extinde tot",
    collapseAllAction = "Restrânge tot",
    columnAccount = "Cont",
    columnContact = "Contact",
    columnType = "Tip",
    columnAddedDate = "Adăugat / creat pe",
    columnSubscription = "Abonament",
    columnSince = "Din",
    columnRenewal = "Reînn.",
    noOrganizationHeader = "Fără organizație",
    emptySearchResult = "Niciun cont nu corespunde acestei căutări.",
    patronBadgePrefix = "Proprietar",
    createdOnPrefix = "Creată pe",
    emptyTeamMessage = "Niciun șofer în această echipă momentan.",
    driverBadge = "Șofer",
    addedOnPrefix = "Adăugat pe",
    viaOrganization = "Prin organizație",
    accountCreatedOnUnknown = "Cont creat pe —",
    renewalSingular = "reînnoire",
    renewalPlural = "reînnoiri",
    subscriptionNone = "Niciunul",
    subscriptionActive = "Activ",
    subscriptionTrial = "Probă",
    subscriptionGrace = "Grație",
    subscriptionExpiredStatus = "Expirat",
    subscriptionCancelled = "Anulat",
    planOrganization = "Organizație",
    planDriver = "Șofer",
)
